import React from 'react';
import { Row, Col } from 'antd';
import DetailItem from "./../../CSIComponents/DetailItem";
import Collapse, { Panel } from '../../ui/Collapse';
import styles from './../index.module.css'


interface propsTypes {
    rowData: void | any
}


const transportationRecord = {
    "type":"",
    "typedetail":"",
    "description":"",
    "charge": null,
    "currency":"",
    "chargeunit":"",
    "included" : null,
    "schedule":[ {
        "startdate": null,
        "enddate": null,
        "operationtime": [
            {
                dayoftheweek: "Mon",
                starttime: " ",
                endtime: " "
            },
            {
                dayoftheweek: "Tue",
                starttime: " ",
                endtime: " "
            },
            {
                dayoftheweek: "Wed",
                starttime: " ",
                endtime: " "
            },
            {
                dayoftheweek: "Thu",
                starttime: "",
                endtime: ""
            },
            {
                dayoftheweek: "Fri",
                starttime: "",
                endtime: ""
            },
            {
                dayoftheweek: "Sat",
                starttime: "",
                endtime: ""
            },
            {
                dayoftheweek: "Sun",
                starttime: "",
                endtime: ""
            }
        ]
        }]
}

const EnergyUsageView = (props: propsTypes | any) => {
    let transportation = props?.rowData?.transportation || []
    if ( transportation.length < 1 ) transportation.push(transportationRecord)
    const data = transportation
    
    return (
        <>
            <Collapse defaultActiveKey={data.map((_: object, i : number) => i)} multiCollapseButton style={{ paddingLeft: 16 }}>
                {data.map((item: any, i: any) => {
                    return (
                        <Panel header={`Transportation ${i + 1}`} key={i} style={{ marginBottom: '20px' }}>
                            <Row gutter={24}>
                                <Col span={6}>
                                    <DetailItem value={item.type} label='Type' />
                                </Col>
                            </Row>
                            <Row gutter={24} className={styles.rowMarginbottom}>
                                <Col span={12}>
                                    <DetailItem value={item.typedetail} label='Type Detail' />
                                </Col>
                            </Row>
                            <Row gutter={24} className={styles.rowMarginbottom}>
                                <Col span={6}>
                                    <DetailItem value={item.included === 'true' ? 'Yes' : (item.included === 'false' ? 'No' : '')} label='Included' />
                                </Col>
                            </Row>
                            <Row gutter={24} className={styles.rowMarginbottom}>
                                <Col span={12}>
                                    <DetailItem value={item.description} label='Description' />
                                </Col>
                            </Row>
                            <Row gutter={24} className={styles.rowMarginbottom}>
                                <Col span={6}>
                                    <DetailItem value={item.charge} label='Charge(Amount)' />
                                </Col>
                                <Col span={6}>
                                    <DetailItem value={item.currency} label='Currency' />
                                </Col>
                                <Col span={6}>
                                    <DetailItem value={item.chargeunit} label='Charge Unit' />
                                </Col>
                            </Row>
                            <div className={styles.rowMarginbottom}></div>
                            <div style={{ marginLeft: 16, marginRight: 16 }}>
                                <Collapse defaultActiveKey={item.schedule.map((_: object, i: number) => `${i}`)} ghost>
                                    {item.schedule?.map((cole: any, j: any) => {
                                        return (
                                            <Panel className="panel-border" header={`Schedule${j + 1}`} key={j}>
                                                {/* <div style={{fontSize: '12px', color: 'rgb(153, 153, 153)', height: '24px'}}> Start Date - End Date</div> */}
                                                <div style={{ marginLeft: 8, marginRight: 8 }}>
                                                    <Row gutter={24} className={styles.rowMarginbottom}>
                                                        <Col span={6}>
                                                            <DetailItem value={cole.startdate} label='Start Date'> </DetailItem>
                                                        </Col>
                                                        <Col span={6}>
                                                            <DetailItem value={cole.enddate} label='End Date' />
                                                        </Col>
                                                    </Row>
                                                    {/* <ApplicalbeDays valueList={valueList} ref={applicalbeDaysRef} /> */}
                                                    {cole.operationtime && cole.operationtime.length > 0 ? <div>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: 34, marginTop: 30, }}>
                                                            <div style={{ display: 'flex', flexDirection: 'column-reverse', marginRight: 5, fontWeight: 'bold', }}>
                                                                <div style={{ height: 35 }}>Close</div>
                                                                <div style={{ height: 35 }}>Open</div>
                                                            </div>
                                                            {cole.operationtime.map(
                                                                (item: any, index: number) => (
                                                                    <div style={{ flex: 1, 'userSelect': 'none' }}>
                                                                        <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>{item.dayoftheweek}</div>
                                                                        <div style={{ fontSize: 14, fontWeight: 500, textAlign: 'center', border: '1px solid #bbb', padding: '20 0' }}>
                                                                            <div style={{ height: 40, lineHeight: '40px', width: '60%', margin: 'auto', cursor: 'pointer' }}><span className="blue-font">{item.starttime}</span></div>
                                                                        </div>
                                                                        <div style={{ fontSize: 14, fontWeight: 500, textAlign: 'center', border: '1px solid #bbb', borderTop: '0', padding: '20 0' }}>
                                                                            <div style={{ height: 40, lineHeight: '40px', width: '60%', margin: 'auto', cursor: 'pointer' }}><span className="blue-font">{item.endtime}</span></div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            )}
                                                        </div>
                                                    </div> : ''}
                                                </div>
                                            </Panel>
                                        )
                                    })}
                                </Collapse>
                            </div>
                        </Panel>
                    )
                })}
            </Collapse>
        </>
    )
}


export default EnergyUsageView;